import type { PlaceSuggestion } from '../domain';

export async function suggestPlaces(q: string): Promise<PlaceSuggestion[]> {
  const res = await fetch(`/places/suggestion?q=${encodeURIComponent(q)}`, {
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    return [];
  }
  return res.json() as Promise<PlaceSuggestion[]>;
}
